import ENVIRONMENT_VAR from "@/shared/models/environment/environments.var";
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { HCreateQuery } from "../../shared/components/refactor/helpers/create-query";
import { RootState } from "../store";
import { OWNERS_TAGS } from "./services/owners/owners-tags";
import { PROPERTY_TAGS } from "./services/realestate/realestate.tags";
import { PROPERTY_DRAFT_TAGS } from "./services/property-draft/property-draft.tags";
import { STATS_TAGS } from "./services/stats/stats.tags";
import { GEO_LOCATION_TAGS } from "./services/geoLocation/geoLocation.tags";
import { AGENCY_TAGS } from "./services/agency/agency.tags";
import { USERS_TAGS } from "./services/users/users.tags";
import { MORTGAGE_TAGS } from "./services/mortgage/mortgage.tags";
import { GENERICS_TAGS } from "./services/generics/generics.tags";
import { MY_ACCOUNT_TAGS } from "./services/myAccount/myAccount.tags";
import { SECTOR_PROPOSALS_TAGS } from "./services/sector-proposals/sector-proposals.tags";

export const mainSplitApi = createApi({
  baseQuery: fetchBaseQuery({
    baseUrl: ENVIRONMENT_VAR.API_URL,
    paramsSerializer: params => HCreateQuery(params),
    prepareHeaders: (headers, { getState }) => {
      const { userLogged } = getState() as RootState;
      headers.set("x-requested-with", "XMLHttpRequest");
      headers.set("x-api-key", ENVIRONMENT_VAR.API_KEY);
      headers.set("X-AUTH-TOKEN", userLogged.maxCoreTokenV1);
      if (userLogged.token)
        headers.set("Authorization", "Bearer " + userLogged.token);
      if (!headers.has("Accept")) headers.set("Accept", "application/json");
      return headers;
    }
  }),
  endpoints: () => ({}),
  tagTypes: [
    ...OWNERS_TAGS,
    ...PROPERTY_TAGS,
    ...PROPERTY_DRAFT_TAGS,
    ...STATS_TAGS,
    ...GEO_LOCATION_TAGS,
    ...AGENCY_TAGS,
    ...USERS_TAGS,
    ...MORTGAGE_TAGS,
    ...GENERICS_TAGS,
    ...MY_ACCOUNT_TAGS,
    ...SECTOR_PROPOSALS_TAGS
  ]
});
